import AuthOrDividerComponent from "./AuthOrDividerComponent";

export default AuthOrDividerComponent;
